<div class="flex flex-col">
    <!-- Contenedor para el texto y el porcentaje -->
    <div class="flex items-start gap-1">
      <span class="text-sm text-gray-500">
        {{ 'Complete profile at' | transloco }}
      </span>
      @if(activateTooltip){
        <mat-icon class="icon-size-3 hover:cursor-pointer"
                matPrefix
                matTooltip="{{'Having a complete profile allows for improved technical assistance' | transloco }}."
                [svgIcon]="'mat_outline:help_outline'"
        ></mat-icon>
      }
    </div>
    <!-- Barra de progreso -->
    <div class="flex flex-row items-center gap-1">
      <mat-progress-bar
        [value]="progress"
        mode="determinate"
      ></mat-progress-bar>
      <span class="text-sm text-gray-500">
        {{ progress }}%
      </span>
    </div>
</div>
